module.exports = __webpack_public_path__ + "img/3.181cd372.png";